__turbopack_context__.v({
  "chevronRight": "FiltersMenu-module__Bvtp8G__chevronRight",
  "closeBtn": "FiltersMenu-module__Bvtp8G__closeBtn",
  "menuHeading": "FiltersMenu-module__Bvtp8G__menuHeading",
  "searchBadge": "FiltersMenu-module__Bvtp8G__searchBadge",
  "searchRowWithBadge": "FiltersMenu-module__Bvtp8G__searchRowWithBadge",
  "selectHint": "FiltersMenu-module__Bvtp8G__selectHint",
  "selectedBadge": "FiltersMenu-module__Bvtp8G__selectedBadge",
  "submenuTrigger": "FiltersMenu-module__Bvtp8G__submenuTrigger",
});
